
export class RecurPatternContext {
    constructor() {

    }
}
